import PropTypes from 'prop-types';
import { Divider, SwipeableDrawer } from '@mui/material';

import { HEADER_HEIGHT } from 'constants/components';

import MenuItemsList from './MenuItemsList';

const DRAWER_TOP_MOBILE = HEADER_HEIGHT - 20;
const DRAWER_TOP_TABLET = HEADER_HEIGHT - 15;

const drawerStyles = ({ breakpoints }) => ({
  top: DRAWER_TOP_MOBILE,
  [breakpoints.up('sm')]: { top: DRAWER_TOP_TABLET },
  [breakpoints.up('lg')]: { top: HEADER_HEIGHT },
});

const paperStyles = ({ palette, breakpoints }) => ({
  top: DRAWER_TOP_MOBILE,
  width: '100%',
  backgroundColor: palette.text.primary,
  [breakpoints.up('sm')]: {
    top: DRAWER_TOP_TABLET,
    width: 'auto',
  },
  [breakpoints.up('lg')]: { top: HEADER_HEIGHT },
});

const dividerStyles = ({ palette }) => ({
  borderColor: palette.colors.darkGrey,
});

const MobileMenu = ({ menuItems, accountMenuItems, isMobileMenuOpen, setIsMobileMenuOpen }) => (
  <SwipeableDrawer
    hideBackdrop
    anchor="right"
    className="remove_for_pdf"
    open={isMobileMenuOpen}
    onOpen={() => setIsMobileMenuOpen(true)}
    onClose={() => setIsMobileMenuOpen(false)}
    slotProps={{ paper: { sx: paperStyles, role: 'navigation', 'aria-label': 'Mobile navigation' } }}
    sx={drawerStyles}
  >
    {!!menuItems.length && (
      <>
        <MenuItemsList items={menuItems} aria-label="Main navigation" />
        <Divider variant="middle" sx={dividerStyles} />
      </>
    )}

    <MenuItemsList items={accountMenuItems} aria-label="Account navigation" />
  </SwipeableDrawer>
);

const menuItemTypes = PropTypes.shape({
  itemKey: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  Icon: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  handleItemClick: PropTypes.func.isRequired,
});

MobileMenu.propTypes = {
  menuItems: PropTypes.arrayOf(menuItemTypes).isRequired,
  accountMenuItems: PropTypes.arrayOf(menuItemTypes).isRequired,
  isMobileMenuOpen: PropTypes.bool.isRequired,
  setIsMobileMenuOpen: PropTypes.func.isRequired,
};

export default MobileMenu;
